'use client';

import React from 'react';
import { IconButton } from 'src/components/PulseUI/IconButton';
import { faSliders } from '@fortawesome/pro-regular-svg-icons';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
const GridTableDrawerButton = ({ location }: { location: string }) => {
  const { closeAllButCurrent } = useDrawer();

  const handleOpenDrawer = () => {
    closeAllButCurrent(`table-filter-${location}`);
  };

  return (
    <IconButton
      variant="outlined"
      color="neutral"
      size="sm"
      onClick={handleOpenDrawer}
      icon={faSliders}
      circular
    />
  );
};

export default GridTableDrawerButton;
